/* eslint-disable max-len */
import {
  useCallback, useEffect, useRef, useState,
} from 'react';
// import { useParams } from 'react-router';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import invertersAction from '@state/inverters/actions';
import devicesApi from '@api/devicesApi';
import invertersApi from '@api/invertersApi';

function useCreateInverters() {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const idToEdit = useSelector(({ inverters: a }) => a.inverterIdToEdit);
  const dataInit = useSelector(({ inverters }) => inverters.createNewInverter);
  const saveState = useSelector(({ inverters }) => inverters.saveState);
  const { inverter_id } = useParams();
  // const listModels = useSelector(({ inverters }) => inverters.listDataModelInverters);
  const [dataModelInverters, setDataModelInverters] = useState([]);
  const [prueba, setPrueba] = useState([]);
  const [deviceId, setDeviceID] = useState([]);
  const backup = useRef(saveState.inverter);
  const [dataForm, setDataForm] = useState(dataInit);
  const unmount = useRef(true);
  const abortC = new AbortController();
  const { signal } = abortC;
  // const body = useSelector(({ device: a }) => a.createNewDevice);
  const skip = 0;
  const limit = 1000;
  const defaultData = {
    code: '',
    client: '',
    solar_capacity: 0,
    storage_capacity: 0,
    inverter_capacity: 0,
    solar_panel_number: 0,
    battery_cycles: 0,
    battery_voltage: 0,
    battery_type: '',
    location: '',
    address: '',
    latitude: 0,
    longitude: 0,
    characteristics: {},
    device_id: '',
    inverter_model_id: '',
  };

  const onFinish = useCallback((values) => { // submit: create device or edit device

    if (!idToEdit) { //  create device

      invertersApi.createInverter({ signal, body: dataInit })
      // eslint-disable-next-line
        .then((response) => {

          // const { id } = response;
          // eslint-disable-next-line no-shadow
          // invertersApi.enableCSDevice({ signal, body: { can_check_cs: true }, id }).then((response) => {
          // });

          if (unmount) {

            message.success(t('views.create_inverter.form.create_success'));
            setDataForm(defaultData);
            dispatch(invertersAction.setCreateEditDevice(defaultData));
            dispatch(invertersAction.setInventerIdEdit(null));
            history.push('/tablero-general/');

          }

        })
        .catch((resError) => {

          console.log(resError);

          if (resError) message.error(resError.data.detail);
          message.error(t('views.create_inverter.form.create_failed'));

        });

    } else { // Edit Device

      invertersApi.editInverter({ signal, body: dataInit, id: idToEdit })
        .then((response) => {

          if (unmount) {

            message.info(t('views.create_inverter.form.edit_success'));
            // eslint-disable-next-line
            setDataForm(defaultData);
            dispatch(invertersAction.setCreateEditDevice(defaultData));
            dispatch(invertersAction.setInventerIdEdit(null));
            history.push('/tablero-general');

          }

        })
        .catch((resError) => {

          message.error(t('views.create_inverter.form.edit_failed'));
          // eslint-disable-next-line
          console.log(resError);

        });

    }

    // eslint-disable-next-line
  }, [dispatch, signal]);

  const onFinishFailed = (errorInfo) => { // data imcomplete

    // eslint-disable-next-line
    console.log(errorInfo.errorFields[0].errors[0]);
    message.error(errorInfo.errorFields[0].errors[0]);

  };

  const getFirmwares = useCallback( // get the firmware data
    () => {

      devicesApi.getAllModelInverters({ signal, skip, limit })
        .then((response) => {

          setDataModelInverters(response);
          dispatch(invertersAction.setGetListModelInverters(response));
          return response;

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [dataModelInverters, dispatch]
  );

  const formOnValuesChange = useCallback( // handle data
    (value) => {

      const key = Object.keys(value);
      const data = Object.values(value);

      if (key[0] === 'inverter_model_id') { // validate by inverter model

        setDataForm({ ...dataForm, [key[0]]: data[0] });
        dispatch(invertersAction.setCreateEditDevice({ ...dataForm, [key[0]]: data[0] }));
        // setDataForm({ ...dataForm, name: data[0], mac: data[0] });
        // dispatch(invertersAction.setCreateEditDevice({ ...dataForm, name: data[0], mac: data[0] }));

      } else {

        setDataForm({ ...dataForm, [key[0]]: data[0] });
        dispatch(invertersAction.setCreateEditDevice({ ...dataForm, [key[0]]: data[0] }));

      }

    },
    // eslint-disable-next-line
    [dataForm, dispatch]
  );

  const getApiKeyId = useCallback( // get the Api key device data
    () => {

      devicesApi.getAllDeviceId({ signal, skip, limit })
        .then((response) => {

          setDeviceID(response);

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [deviceId, dispatch]
  );

  const cancelCreateEditDevice = useCallback(
    () => {

      dispatch(invertersAction.setCreateEditDevice(defaultData));
      history.push('/tablero-general');

    },
    // eslint-disable-next-line
    [],

  );

  const goToCreateDevice = () => {

    backup.current = true;
    dispatch(invertersAction.setSaveState({
      inverter: true,
      device: false,
    }));
    history.push('/dispositivos/crear-dispositivo');

  };

  const goToCreateInverterModel = () => {

    backup.current = true;
    dispatch(invertersAction.setSaveState({
      inverter: true,
      device: false,
    }));
    history.push('/dispositivos/model-inverters/crear-model-inverter');

  };

  useEffect(() => { // mount component

    getFirmwares();
    getApiKeyId();
    if (!idToEdit) { // Validate is edit

      const locat = location.pathname.replace(inverter_id, '');
      if (locat === '/inversores/editar/') {

        history.push('/tablero-general');

      }

    }
    return function cleanUp() {

      unmount.current = false;
      if (!backup.current || idToEdit) {

        dispatch(invertersAction.setCreateEditDevice(defaultData));
        dispatch(invertersAction.setInventerIdEdit(null));

      }

    };
  // eslint-disable-next-line
  }, []);

  return {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm,
    idToEdit,
    cancelCreateEditDevice,
    deviceId,
    dataModelInverters,
    setPrueba,
    prueba,
    goToCreateDevice,
    goToCreateInverterModel,
  };

}

export default useCreateInverters;
